import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js"
import { Ref, ref } from "vue"

export const isFancyboxOpen: Ref<boolean> = ref(false)

let hasHistoryEntry = false

function closeOnBrowserBack(event: PopStateEvent) {
  event.stopImmediatePropagation()
  hasHistoryEntry = false
  window.removeEventListener("popstate", closeOnBrowserBack, true)
  Fancybox.close()
}

/**
 * Gives the preview one same-URL history entry so browser Back closes it without
 * navigating away from the current Item.
 */
const historyEvents = {
  init: () => {
    isFancyboxOpen.value = true
    window.history.pushState(window.history.state, "", window.location.href)
    hasHistoryEntry = true
    window.addEventListener("popstate", closeOnBrowserBack, true)
  },
  closing: () => {
    isFancyboxOpen.value = false
    if (hasHistoryEntry) window.history.back()
  },
  destroy: () => {
    isFancyboxOpen.value = false
  }
}

Fancybox.defaults.on = {
  ...Fancybox.defaults.on,
  ...historyEvents
}

export const bindFancyBox = ({
  id,
  options,
  enableHash
}: {
  id: string
  options
  enableHash?: boolean
}) => {
  Fancybox.bind(id, {
    ...options,
    on: {
      ...options.on,
      init: historyEvents.init,
      destroy: historyEvents.destroy,
      closing: (...args) => {
        historyEvents.closing()
        options.on?.closing?.(...args)
      }
    }
  })
  Fancybox.defaults.Hash = !!enableHash
  return Fancybox
}
